module.exports = __webpack_public_path__ + "static/img/serve8.34a2adab.png";